module.exports = __webpack_public_path__ + "static/media/aric.5790e80e.jpg";